import firebase from 'firebase/app'
import 'firebase/firestore'
import { Logger } from '@/js/utils/Logger.js'
import { DateIsBetween } from "@/js/CommonFunc.js";


export default class AcrylicTicketCouponManager {
    constructor() {
      this.eventList = [];          // イベントのリスト
      this.issueHistory = [];       // 全発行履歴
      this.ticketIssueHistory = [];
      this.orderData = {
        acrylicTicketSettingDocId:"",
        count:0,
        unitPrice:0,          // 単価、送料がここに含まっている場合もある
        productId:"",
        ticketProductId:"",
        isShippingFee:false,  // 送料も払うか
        fromDate:"",
        toDate:"",
        preview:"",
      }

      this.selectEditSetting = {};  // 画面遷移時の受け渡し用
      this.selectTicketIssueData = {};  // 画面遷移時の受け渡し用

      this.lastAddDocumentId = "";  // 最後に追加されたドキュメントのID

      // this.editData = {};
      this.resetEditData();
    }

    resetOrderData(){
      this.orderData = {
        acrylicTicketSettingDocId:"",
        isUserEdit:false,
        count:1,
        unitPrice:0,          // 単価、送料がここに含まっている場合もある
        productId:"",
        ticketProductId:"",
        isShippingFee:false,  // 送料も払うか
        fromDate:"",
        toDate:"",
        preview:"",
      }
    }

    async update() {
      Logger.info("AcrylicTicketCouponManager:update");

      await this.getEventData();
    }

    async getEventData(){
      const ref = firebase.firestore().collection("AcrylicTicketSetting");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).orderBy("createdAt", "desc").get();

      this.eventList = [];

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        data.docId = snapshot.docs[i].id;
        const Setting = new AcrylicTicketSetting(data);
        // 削除されていないものだけ表示
        if( !Setting.isStop ){
          this.eventList.push(Setting);
        }
      }

      // ついでに全発行履歴も取得する
      this.issueHistory = [];
      const ref2 = firebase.firestore().collection("AcrylicTicketIssueHistory");
      const snapshot2 = await ref2.where("uid", "==", firebase.auth().currentUser.uid).orderBy("createdAt", "desc").get().catch((e)=>{
        console.log(e);
      });
      for( let i = 0; i<snapshot2.docs.length; ++i ){
        const data = snapshot2.docs[i].data();
        this.issueHistory.push(data);
      }
    }

    async setEventData( docId ){
      const doc = await firebase.firestore().collection("AcrylicTicketSetting").doc(docId).get();
      if( doc.exists ){
        const data = doc.data();
        data.docId = docId;
        this.selectEditSetting = new AcrylicTicketSetting(data);
      }
    }

    async deleteEventData(docId){
      let setting = {
        isStop: true,
        updatedAt: new Date(),
      };

      await firebase.firestore().collection("AcrylicTicketSetting").doc(docId).update(setting);
    }

    // 指定のイベントに有効なコードが存在するか
    isIssueTicketEvent( eventDocId )
    {
      for( const issue of this.issueHistory ){
        if( issue.acrylicTicketSetting == eventDocId &&
          DateIsBetween(new Date(), issue.validFrom.toDate(), issue.validTo.toDate()) ){
          return true;
        }
      }

      return false;
    }

    // イベントデータを保存
    async saveEventData(setting){
      if( setting.docId ){
        await this.updateEventData(setting);
      }else{
        await this.createEventData(setting);
      }
    }

    async createEventData(setting){
      setting.uid = firebase.auth().currentUser.uid;
      setting.isStop = false;
      setting.createdAt = new Date();
      setting.updatedAt = new Date();

      Logger.debug("add");
      Logger.debug(setting);
      const docRef = await firebase.firestore().collection("AcrylicTicketSetting").add(setting);
      this.lastAddDocumentId = docRef.id;
    }

    async updateEventData(setting){
      const docId = setting.docId ?? "";
      if( !docId ){
        Logger.error("docId未設定");
        return;
      }

      setting.updatedAt = new Date();

      Logger.debug("update");
      Logger.debug(setting);
      await firebase.firestore().collection("AcrylicTicketSetting").doc(docId).update(setting);
    }

    // チケット発行履歴を取得
    async getTicketIssueHistory(docId){
      this.ticketIssueHistory = [];
      const ref = firebase.firestore().collection("AcrylicTicketIssueHistory");
      const snapshot = await ref.where("acrylicTicketSetting", "==", docId).orderBy("createdAt", "desc").get().catch((e)=>{
        console.log(e);
      });

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        data.docId = snapshot.docs[i].id;

        // 発行状態も取得する
        const doc = await firebase.firestore().collection("AcryCouponCodeIssuedHistory").doc(data.acryCouponCodeIssuedHistory).get();
        console.log(doc);
        if( doc.exists ){
          // 発行してすぐの場合はドキュメントがない場合がある
          this.ticketIssueHistory.push(new AcrylicTicketIssue(data, doc.data()));
        }
      }
      return this.ticketIssueHistory;
    }

    // チケット発行履歴を取得
    async getAcryCouponCode(issuedId){
      let codes = [];
      const ref = firebase.firestore().collection("AcryCouponCode");
      const snapshot = await ref.where("issuedId", "==", issuedId).orderBy("issuedAt", "desc").get();

      for( let i = 0; i<snapshot.docs.length; ++i ){
        let data = snapshot.docs[i].data();
        data.docId = snapshot.docs[i].id;
        codes.push(data);
      }

      return codes;
    }

    // チケット発行履歴を取得
    async getAllAcryCouponCode(settingDocId){
      let codes = [];
      const ref = firebase.firestore().collection("AcryCouponCode");
      const snapshot = await ref.where("acrylicTicketSetting", "==", settingDocId).orderBy("issuedAt", "desc").get();

      for( let i = 0; i<snapshot.docs.length; ++i ){
        let data = snapshot.docs[i].data();
        data.docId = snapshot.docs[i].id;
        codes.push(data);
      }

      return codes;
    }

    // チケットを発行したことがあるかをチェック
    async isTicketIssued(settingDocId){
      const ref = firebase.firestore().collection("AcryCouponCode");
      const snapshot = await ref.where("acrylicTicketSetting", "==", settingDocId).get();
      return !snapshot.empty;
    }

    /**
     * コードの使用状況等の情報を取得する
     * @param {String} code 調べたいコード
     * @returns 
     */
    async getTicketData(code){
      const snapshot = await firebase.firestore().collection("AcryCouponCode").doc(code).get();
      if( !snapshot.exists ){
        return null;
      }

      // 自分自身が所有しているかチェック
      const CodeData = snapshot.data();
      const SettingId = CodeData.acrylicTicketSetting;
      const snapshot2 = await firebase.firestore().collection("AcrylicTicketSetting").doc(SettingId).get();
      if( !snapshot2.exists ){
        return null;
      }

      const SettingData = snapshot2.data();
      return (SettingData.uid == firebase.auth().currentUser.uid)?CodeData:null;
    }

    /**
     * コードを使用して行った注文のデータを取得する
     * @param {String} code 調べたいコード
     * @returns 
     */
    async getTicketUsedOrderId(code){
      const ref = firebase.firestore().collection("AcryCouponCodeUsedHistory");
      const snapshot = await ref.where("code", "==", code).get();
      if(snapshot.empty){
        return null;
      }

      return snapshot.docs[0].data().orderId;
    }

    resetEditData(){
      this.editData = {};
      // this.editData.eventName = "";
      // this.editData.issuerName = "";
      // this.editData.size = "S";
    }
}


class AcrylicTicketSetting {
  constructor(setting){
    this.docId = setting.docId ?? "";
    this.uid = setting.uid ?? "";
    this.name = setting.name ?? "";
    this.issuerName = setting.issuerName ?? "";
    this.banner1 = setting.banner1 ?? "";
    this.banner2 = setting.banner2 ?? "";
    this.design = setting.design ?? "";
    this.cutline = setting.cutline ?? "";
    this.preview = setting.preview ?? "";
    this.folderName = setting.folderName ?? "";
    this.isUserEdit = setting.isUserEdit ?? false;
    this.nonEditable = setting.nonEditable ?? "";
    this.isStop = setting.isStop ?? false;
    this.isShippingFee = setting.isShippingFee ?? false;  // trueはユーザー負担
    this.size = setting.size ?? "";
    this.createdAt = setting.createdAt ?? "";
    this.updatedAt = setting.updatedAt ?? "";
    this.configured = setting.configured ?? false;

    // this.isValid = false;
    // this.status = "";
  }

  // function getStatus()
  // {
  //   // UTC での現在日時
  //   const now = new Date();
  //   const now = new Date();
  //   const now = new Date();



  // }
  
  // function getIsValid(){

  // }
}


class AcrylicTicketIssue {
  constructor(issueData, issuedData){
    // 発行に関するデータ(AcrylicTicketIssueHistory)
    this.docId = issueData.docId;
    this.uid = issueData.uid;
    this.orderId = issueData.orderId;
    this.acryCouponCodeIssuedHistory = issueData.acryCouponCodeIssuedHistory;
    this.acrylicTicketSetting = issueData.acrylicTicketSetting;
    this.createdAt =  issueData.createdAt.toDate();
    this.validFrom =  issueData.validFrom.toDate();
    this.validTo =  issueData.validTo.toDate();

    // 発行の状態に関するデータ(AcryCouponCodeIssuedHistory)
    this.issued = issuedData.issued;
    this.issuedCount = issuedData.issuedCount;
    this.requestCount = issuedData.requestCount;
    if( issuedData.issued ){
      this.completionDate = issuedData.completionDate.toDate();
    }else{
      this.completionDate = "";
    }
  }
}


export { AcrylicTicketCouponManager }